export const TITLE_TEXT = `У тех, кто завтра не придет,
рейтинг в гору не попрет!`;
